import useLatestShareData from "../shares/useLatestShareData";
import { getPlaceholderFieldsConfig } from "@/components/tiptap-editor/extensions/placeholder";
import useSendEmailJobRecords from "@/hooks/notifications/useSendEmailJobRecords";

export default (recipients, editor) => {
  const { data: latestShareDataQuery } = useLatestShareData();
  const latestShareData = latestShareDataQuery?.data;
  const shareTypes = latestShareData?.types?.map((t) => t.shareType);
  const { data: sendEmailJobRecords, isLoading } = useSendEmailJobRecords(
    recipients,
    editor,
  );

  if (!sendEmailJobRecords) {
    return {
      placeholderStatuses: undefined,
      placeholdersUsed: undefined,
      isLoading,
    };
  }

  const placeholdersUsed = new Set();
  const placeholderNodes = [];
  const supportedPlaceholderFields = getPlaceholderFieldsConfig({ shareTypes });

  editor.state.doc.descendants((node) => {
    if (node.type.name !== "placeholder") return;
    placeholderNodes.push(node);
  });

  placeholderNodes.forEach((node) => {
    if (node.attrs.name === "calculation") {
      supportedPlaceholderFields.forEach((field) => {
        if (node.attrs.value.includes(field.id)) {
          placeholdersUsed.add(field.id);
        }
      });
    } else {
      placeholdersUsed.add(node.attrs.name);
    }
  });

  let missingPlaceholderValuesCount = 0;

  const placeholdersUsedArr = Array.from(placeholdersUsed);

  const placeholderStatuses = sendEmailJobRecords.reduce(
    (recipientAcc, recipient) => ({
      ...recipientAcc,
      [recipient.id]: placeholdersUsedArr.reduce(
        (placeholderAcc, placeholderId) => {
          const placeholderValue = recipient.record?.[placeholderId] ?? null;

          if (placeholderValue === null) {
            missingPlaceholderValuesCount++;
          }

          const { record: _record, body: _body, ...recipientInfo } = recipient;

          return {
            ...placeholderAcc,
            ...recipientInfo,
            hasMissingValues:
              placeholderAcc.hasMissingValues || placeholderValue === null,
            values: {
              ...placeholderAcc.values,
              [placeholderId]: placeholderValue,
            },
          };
        },
        {},
      ),
    }),
    {},
  );

  return {
    supportedPlaceholderFields,
    placeholderStatuses,
    placeholdersUsed: placeholdersUsedArr,
    missingPlaceholderValuesCount,
    isLoading,
  };
};
